import { useEffect, useMemo, useSyncExternalStore } from "react";
import { CourseOption, CourseSummary } from "../types/course.response";
import {
    composeCourseOption,
    ensureHydrated,
    getCatalogEntry,
    getCatalogVersion,
    subscribeCatalog,
} from "../services/courseCatalog";

/**
 * 渲染边界的补水 hook:传入需要完整数据的课程摘要(通常是某区块的可见切片),
 * 触发批量补水并订阅缓存;返回 mapKey → 合成后的完整 CourseOption。
 * 未到位的 key 不在返回 Map 中,调用方渲染占位行。
 */
export function useHydratedCourses(summaries: CourseSummary[]): Map<string, CourseOption> {
    const catalogVersion = useSyncExternalStore(subscribeCatalog, getCatalogVersion);

    const keysSignature = summaries.map(s => s.mapKey).join("\u0000");

    useEffect(() => {
        if (summaries.length === 0) return;
        ensureHydrated(summaries.map(s => s.mapKey)).catch(err => {
            console.error("Error hydrating courses:", err);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keysSignature]);

    return useMemo(() => {
        const hydrated = new Map<string, CourseOption>();
        for (const summary of summaries) {
            const catalog = getCatalogEntry(summary.mapKey);
            if (catalog) {
                hydrated.set(summary.mapKey, composeCourseOption(summary, catalog));
            }
        }
        return hydrated;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keysSignature, summaries, catalogVersion]);
}
